<template>
  <div class="container">
    <div class="large-12 medium-12 small-12 cell d-flex flex-column my-5">
        <input

          type="file"
          id="files"
          ref="files"
          multiple
          v-on:change="handleFilesUpload()"
        />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AngebotService from "@/services/AngebotService.js";
import ImageService from "@/services/ImageService.js";
import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect, mdbSelectOption } from 'mdbvue';
export default {
  components: {
    mdbBtn,
    mdbInput,
    mdbDatePicker,
    mdbSelect,
    mdbSelectOption
  },
  data() {
    return {
      files: ""
    };
  },

  methods: {
      submitFiles() {
          let angebotId = "2n1n2enn1ndn12e1e2";
          let fData = new FormData();

          for( var i = 0; i < this.files.length; i++ ){
              let file = this.files[i];

              let newName = angebotId + "-" + file.name;
              const newFile = new File([file], newName, {type: file.type});

              fData.append('files[' + i + ']', newFile);
          }
          ImageService.deleteImages(angebotId).then(function(){
              ImageService.addImages(fData).then(function(){
                  console.log('SUCCESS!!');
              }).catch(function(){
                  console.log('FAILURE!!');
              });
          }).catch(function(){
              console.log('FAILURE!!');
          });

      },
    handleFilesUpload() {
        //this.files = this.$refs.files.files;
        this.$parent.files = this.$refs.files.files;
    }
  }
};
</script>
